import {
  createListenerMiddleware,
  type TypedStartListening,
} from '@reduxjs/toolkit';

import type { AppDispatch, RootState } from 'features/app/store/store';
import { callIdSelector } from 'features/call/call-base/store/selectors';
import { AstSignMailHandoffStatus } from 'features/ast-signmail/interfaces';

import {
  selectAstSignMailHandoffStatus,
  selectAstSignMailMode,
  selectHasAstSignMailHandoffSucceeded,
} from './astSignMailSelectors';
import { resetAstSignMail } from './astSignMailSlice';

// resetCall already returns this slice to its initial state. Matching the
// action type avoids a call-slice import cycle.
const RESET_CALL_ACTION_TYPE = 'call/resetCall';

const listenerMiddleware = createListenerMiddleware();

type AppStartListening = TypedStartListening<RootState, AppDispatch>;
const startListening = listenerMiddleware.startListening as AppStartListening;

startListening({
  predicate: (action, currentState, previousState) => {
    if (action.type === RESET_CALL_ACTION_TYPE) {
      return false;
    }

    if (callIdSelector(currentState) === callIdSelector(previousState)) {
      return false;
    }

    return (
      selectAstSignMailHandoffStatus(currentState) !==
        AstSignMailHandoffStatus.INACTIVE ||
      selectHasAstSignMailHandoffSucceeded(currentState) ||
      selectAstSignMailMode(currentState) !== undefined
    );
  },
  effect: (_action, listenerApi) => {
    listenerApi.dispatch(resetAstSignMail());
  },
});

export const astSignMailCallIdListenerMiddleware =
  listenerMiddleware.middleware;
